import { Button, Image, Switch, Tag } from "ant-design-vue";
import classNames from "classnames";
import { h } from "vue";
import type { CustomRenderParams } from "./types";

export const renderers = ({ text, column, record, index }: CustomRenderParams) => {
	if (!column.customColumn) {
		return text;
	}

	const customColumn = column.customColumn;
	const { type, ...config } = customColumn;

	switch (type) {
		case "image": {
			return h(Image, {
				src: text,
				...config,
			});
		}

		case "operate": {
			const buttons = customColumn.buttons;

			const buttonsToShow = buttons.filter((button) => {
				if (typeof button.hidden === "function") {
					return !button.hidden(record);
				}

				return !button.hidden;
			});

			return h(
				"div",
				{
					class: classNames("flex", "gap-x-md", "gap-y-ts", "flex-wrap", {
						"justify-center": column.align === "center",
						"justify-end": column.align === "right",
						"justify-start": column.align === "left",
					}),
				},
				buttonsToShow.map((button) =>
					h(
						Button,
						{
							type: button.type || "link",
							class: classNames({ "!p-0": button.type === "link" || button.type === "text" }),
							...button,
							hidden: false,
							onClick: () => button.onClick && button.onClick({ record, column, index }),
						},
						{
							default: () =>
								typeof button.text === "function" ? button.text(record) : button.text,
						}
					)
				)
			);
		}

		case "status":
			return h(Switch, {
				checked:
					typeof customColumn.checked === "function"
						? customColumn.checked(record)
						: customColumn.checked,
				onChange: (checkedValue) => {
					customColumn?.onChange?.(Boolean(checkedValue), record);
				},
			});
		case "tags":
			const tagText = customColumn.render ? customColumn.render(record) : "";

			return h(
				Tag,
				{
					...(customColumn.props || {}),
					color:
						typeof customColumn.color === "function"
							? customColumn.color(record)
							: customColumn.color,
				},
				() => tagText || customColumn.text || text
			);
		case "text":
			return h("span", {}, text);
		default:
			return text;
	}
};
